// Parser de códigos de balanza (EAN-13 con peso/precio embebido).
//
// Formato más común en Argentina (Kretz/Systel y similares): EAN-13 cuyo
// primer dígito es 2 (rango reservado 20–29 para uso interno del comercio).
//   posición 0      : prefijo "2"
//   posiciones 1..6 : código de artículo / PLU (6 dígitos)
//   posiciones 7..11: valor embebido (5 dígitos) → peso en gramos o precio en centavos
//   posición 12     : dígito verificador
//
// Si tu balanza usa otra distribución, ajustá las constantes de abajo.
const PREFIX = '2';
const PLU_START = 1;
const PLU_LEN = 6;
const VALUE_START = 7;
const VALUE_LEN = 5;

export interface ScaleBarcode {
  /** Código de artículo (PLU) sin ceros a la izquierda. */
  plu: string;
  /** Peso en kg si el producto se vende por peso. */
  weightKg: number;
  /** Precio total embebido (en $) si el código trae precio. */
  embeddedPrice: number;
}

/** Devuelve los datos del código de balanza, o null si no es uno. */
export function parseScaleBarcode(raw: string): ScaleBarcode | null {
  const code = (raw || '').trim();
  if (!/^\d{13}$/.test(code)) return null;
  if (code[0] !== PREFIX) return null;

  const pluDigits = code.substr(PLU_START, PLU_LEN);
  const valueDigits = code.substr(VALUE_START, VALUE_LEN);
  const plu = String(parseInt(pluDigits, 10)); // sin ceros a la izquierda
  const value = parseInt(valueDigits, 10);

  return {
    plu,
    weightKg: value / 1000, // 5 dígitos en gramos
    embeddedPrice: value / 100, // 5 dígitos en centavos
  };
}
